import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from '../../../models/order.model';

@Component({
  standalone: false,
  selector: 'app-additional-warning-info',
  templateUrl: './additional-warning-info.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class AdditonalWarningInfoComponent {
  @Input() order: Order;

  @Output() readonly responseChanged = new EventEmitter();

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
